import type { SVGProps } from 'react';
const SvgSendAndArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#send_and_archive_svg__a)">
      <path
        fill="currentColor"
        d="M21 10h-3L2 3v7l9 2-9 2v7l8-3.5V21c0 1.1.9 2 2 2h9c1.1 0 2-.9 2-2v-9c0-1.1-.9-2-2-2Zm0 11h-9v-9h9v9Zm-4.5-1L13 16h2v-3h3v3h2l-3.5 4Z"
      />
    </g>
    <defs>
      <clipPath id="send_and_archive_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSendAndArchive;
